<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="45">


    <mat-card *ngIf="customer" class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Customer</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title style="align-items: center;">
              <mat-icon matTooltip="identified" *ngIf="customer && customer.identStatus == identStatus.success" color="primary">beenhere
              </mat-icon>
              <mat-icon matTooltip="not identified" *ngIf="customer && customer.identStatus != identStatus.success" color="warn">cancel
              </mat-icon>
              &nbsp;&nbsp;{{ customer.firstName }} {{ customer.lastName }}
            </mat-panel-title>
            <mat-panel-description>
              {{ customer.address }}, {{ customer.zipCode }} {{ customer.city }} <flag-icon style="padding-left: 5px;" country="{{ ohByNumeric[customer.countryIsoCode.toString().padStart(3, '0')].alpha2.toLowerCase() }}"></flag-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="list-item" fxLayout="row" *ngFor="let field of fields">
            <app-content-row [field]="field" [entity]="customer"></app-content-row>
          </div>

        </mat-expansion-panel>

        <div style="margin-top: 10px; padding: 10px; margin-bottom: 10px;">
          <h4>Ident Level</h4>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Ident Level</label>
            <label [fxFlex]="32" *ngIf="customer">
              <mat-select placeholder="Select new IDV level" [(value)]="newIdvLevelSelect">
                <mat-option [value]="identLevel.Unknown">0: Unknown</mat-option>
                <mat-option [value]="identLevel.Sdd">1: SDD</mat-option>
                <mat-option [value]="identLevel.Fdd">2: FDD</mat-option>
                <mat-option [value]="identLevel.Edd">3: EDD</mat-option>
              </mat-select>
            </label>
            <label [fxFlex]="33" *ngIf="customer" style="text-align: right">
              <button mat-raised-button class="mr-1" color="blue" [disabled]="(!currentUserIsAdminOrCompliance()) || newIdvLevelSelect == null || newIdvLevelSelect == customer.identLevel || newIdvLevelSelect === identLevel.Unknown" (click)="setCustomerIdLevel(newIdvLevelSelect)"><mat-icon>account_box</mat-icon> Set new Ident Level</button>
            </label>
          </div>
        </div>


        <div style="margin-top: 20px; margin-bottom: 0px; margin-left: 15px;">
          <b>Cards</b>
        </div>
        <mat-table [dataSource]="customer?.cards">
          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let card"> <a [routerLink]="'../../cards/'+card.id"><mat-icon>visibility</mat-icon></a>  </mat-cell>
          </ng-container>
          <ng-container matColumnDef="token">
            <mat-header-cell *matHeaderCellDef> Token</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{card.token}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="product">
            <mat-header-cell *matHeaderCellDef> Product</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{card.product?.shortName || card.product?.name || '-'}} </mat-cell>
          </ng-container>

          <!-- Age Definition -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
            <mat-cell *matCellDef="let card"> {{ card.statusName }} </mat-cell>
          </ng-container>

          <!-- Title Definition -->
          <ng-container matColumnDef="expiry">
            <mat-header-cell *matHeaderCellDef> Expiry</mat-header-cell>
            <mat-cell
              *matCellDef="let card"> {{card.expireDate ? (card.expireDate.substring(5, 7) + "/" + card.expireDate.substring(2, 4)) : "-" }} </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <mat-header-row *matHeaderRowDef="['link', 'token', 'product', 'status', 'expiry']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['link', 'token', 'product', 'status', 'expiry']"></mat-row>
        </mat-table>


      </mat-card-content>
      <mat-card-actions align="end">

        <button mat-raised-button class="mr-1" color="blue" [disabled]="isIdvDisabled(customer)"
                (click)="sendIdvLink(customer)">IDV
        </button>
        <button mat-raised-button class="mr-4" color="blue" [disabled]="true || isDocsDisabled(customer)"
                (click)="sendDocsLink(customer)">Docs
        </button>
        <button mat-raised-button class="mr-4" color="blue" [disabled]="isSofGenericDisabled(customer)"
                (click)="sendSofGenericLink(customer)">Request SOF
        </button>


        <!--<button mat-raised-button style="margin-right: 5rem;" color="primary"
                *ngIf="customer && currentUserIsAdminOrCompliance()" [disabled]="!currentUserIsAdminOrCompliance()"
                (click)="createInternalDocsLink(customer)">Upload Docs</button>-->


        <button mat-raised-button color="primary" [disabled]="!prevNext?.prev"
                (click)="gotoPrevCustomer()">Previous
        </button>
        <button mat-raised-button color="primary" [disabled]="!prevNext?.next" (click)="gotoNextCustomer()">Next
        </button>


      </mat-card-actions>

      <hr *ngIf="docInvoice != null && !isDocsResendHidden && !customer?.archived"/>
      <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
        {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br/><br/>
        <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled"
                (click)="resendDocsLink(customer)">resend Doc Link
        </button>
        <button mat-raised-button class="mr-4" color="primary"
                [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount"
                (click)="resendDocsPaymentLink(customer)">resend payment link
        </button>
        <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled"
                (click)="resendDocsInvoice(customer)">send Invoice
        </button>
      </div>
    </mat-card>

    <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
      <mat-card-header>
        <mat-card-title>
          <h5>IDV</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
          <tr>
            <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
            <th style="text-align: left; width: 60px;"><label>Type</label></th>
            <th style="text-align: left;"><label>File</label></th>
            <th style="text-align: left; width: 160px;"><label>Doc Type</label></th>
            <th style="text-align: left"><label>Status</label></th>
            <th style="text-align: left; width: 50px;"></th>
            <th style="text-align: left; width: 50px;"></th>
          </tr>

          <tr *ngFor="let f of idvUploadFiles">
            <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
            <td><label>{{f.typName}}</label></td>
            <td>
              <label *ngIf="currentUserIsAdminOrManager()">
                {{ f.originalFileName }}
              </label>
            </td>
            <td>
              <label>
                {{f.docType}}
              </label>
            </td>
            <td>
              <app-tri-state-checkbox [disabled]="isSaveIdvDisabled" *ngIf="f.mailSentDate == null"
                                      style="margin-right: 3px;" [(ngModel)]="f.isSuccess"></app-tri-state-checkbox>
              <label *ngIf="f.isSuccess == true">Success</label>
              <label *ngIf="f.isSuccess == false">Failed</label>
              <label *ngIf="f.isSuccess == null">Select</label>

            </td>
            <td>
              <button mat-mini-fab color="accent" (click)="downloadFile(f.id)" aria-label="download">
                <mat-icon matSuffix>cloud_download</mat-icon>
              </button>

            </td>
            <td>
              <button mat-mini-fab color="primary" (click)="openFile(f.id)" aria-label="preview">
                <mat-icon matSuffix>play_arrow</mat-icon>
              </button>

            </td>

          </tr>
        </table>

        <mat-card-actions align="end" *ngIf="customer">

          <div style="margin-right: 20px; margin-top: 10px;"
               [hidden]="idvUploadFiles == null || idvUploadFiles.length <= 0 || isSaveIdvDisabled">
            <label>Customer:&nbsp;&nbsp;</label>
            <app-tri-state-checkbox style="margin-left: 5px;"
                                    [disabled]="idvUploadFiles == null || idvUploadFiles.length <= 0"
                                    [(ngModel)]="customer.idvSuccess">
              <label *ngIf="customer.idvSuccess == true">Success</label>
              <label *ngIf="customer.idvSuccess == false">Failed</label>
              <label *ngIf="customer.idvSuccess == null">Pending</label>
            </app-tri-state-checkbox>

          </div>

          <button mat-raised-button color="primary"
                  [disabled]="idvUploadFiles == null || idvUploadFiles.length <= 0 || isSaveIdvDisabled"
                  au (click)="save(idvUploadFiles)">Save and inform customer
          </button>
        </mat-card-actions>


      </mat-card-content>
    </mat-card>

    <!-- SOF Generic -->

    <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
      <mat-card-header>
        <mat-card-title>
          <h5>Source of funds</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="currentUserIsAdminOrComplianceOrManager() && lastSofGenericLinkToken != null" style="margin-bottom: 15px;">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5>Upload documents</h5>
              </mat-panel-title>
              <mat-panel-description>

              </mat-panel-description>
            </mat-expansion-panel-header>


            <ngx-dropzone (change)="onSelectSofGeneric($event)" [accept]="'image/*, application/pdf'" [multiple]="true"
                          [maxFileSize]="10485760" [disabled]="!currentUserIsAdminOrComplianceOrManager()">
              <ngx-dropzone-label *ngIf="true">UPLOAD</ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of filesSofGeneric" [removable]="true" (removed)="onRemoveSofGeneric(f)">
                <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
            <div [hidden]="!isUploading">
              <div class="spinner-2">
                <mat-spinner align="center"></mat-spinner>
              </div>
            </div>
            <button style="margin-top: 5px; margin-bottom: 15px;" *ngIf="true"
                    [disabled]="filesSofGeneric == null || filesSofGeneric.length <= 0 || isUploading" mat-raised-button color="primary" type="button"
                    (click)="uploadToSofGeneric()">Upload
            </button>
          </mat-expansion-panel>
        </div>


        <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
          <tr>
            <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
            <th style="text-align: left; width: 120px;"><label>Type</label></th>
            <th style="text-align: left;"><label>File</label></th>
            <th style="text-align: left; width: 160px;"><label>Doc Type</label></th>
          </tr>


          <ng-container  *ngFor="let f of sofGenericUploadFiles">
            <tr [class.noborderbottom]="f.comment">
              <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
              <td><label>{{getSofTypeName(f.typName)}}</label></td>
              <td><label>{{f.docType}}</label></td>
              <td>
                <label *ngIf="currentUserIsAdminOrCompliance()">
                  <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                </label>
                <label *ngIf="!currentUserIsAdminOrCompliance()">
                  {{ f.originalFileName }}
                </label>
              </td>
              <td>
                <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                <label *ngIf="f.isSuccess == null">-</label>
              </td>
            </tr>
            <ng-container *ngIf="f.comment">
              <tr>
                <td colspan="4" style="border-top: none; font-size: .9em;">
                  <div>
                    📑 {{f.comment}}
                  </div>
                  <div style="font-weight: bold; font-size: .9em; padding-left: 5px;font-family: monospace">
                    {{f.decisionUserInitials}} ({{f.decisionUserEmail}})
                  </div>
                </td>

              </tr>
            </ng-container>

          </ng-container>

          <!--<tr *ngFor="let f of sofGenericUploadFiles">
            <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
            <td><label>{{f.typName}}</label></td>
            <td>
              <label *ngIf="currentUserIsAdminOrManager()">
                {{ f.originalFileName }}
              </label>
            </td>
            <td>
              <label>
                {{f.docType}}
              </label>
            </td>

          </tr>-->
        </table>

        <mat-card-actions align="end" *ngIf="customer">

          <div style="margin-right: 15px;">
            <button mat-raised-button (click)="goToSofGenericDetail(customerId)">
              <mat-icon>assignment</mat-icon> Review
            </button>
          </div>

        </mat-card-actions>


      </mat-card-content>
    </mat-card>


    <!-- BTL -->

    <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent()">
      <mat-card-header>
        <mat-card-title>
          <h5>Bank Transfer Loads</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
          <tr>
            <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
            <th style="text-align: left; width: 100px;"><label>Amount</label></th>
            <th style="text-align: left;"><label>CounterAccount</label></th>
          </tr>
          <tr *ngFor="let btl of openBankTransferLoads">
            <td class="">
              <label>{{ btl.statementDate | date: "dd.MM.yyyy" }}</label>
              <ng-container *ngIf="btl.isApprovedManually">
                <div style="background-color: forestgreen; border-radius: 3px; padding: 2px 5px; margin: 5px 0; font-size: .8em">Manually approved</div>
              </ng-container>
              <ng-container *ngIf="btl.isDeclinedManually">
                <div style="background-color: red; border-radius: 3px; padding: 2px 5px; margin: 5px 0; font-size: .8em">Declined</div>
              </ng-container>
              <ng-container *ngIf="btl.isExported">
                <div style="background-color: lightskyblue; border-radius: 3px; padding: 2px 5px; margin: 5px 0; font-size: .8em">Exported</div>
              </ng-container>
            </td>
            <td>
              <label>{{btl.amountToLoad}}</label>
            </td>
            <td>
              <label>
                {{btl.trustPayTransaction?.counterAccountName}}<br/>
                {{btl.trustPayTransaction?.counterAccountMasked}}
              </label>
            </td>
            <td style="text-align: right;">

              <!--<button style="margin-right: 10px;" mat-raised-button color="primary"
                      (click)="approveBankTransferLoadDocs(btl.id)">
                <mat-icon>verified_user</mat-icon>
                Approve Docs for this load
              </button>-->

              <button mat-raised-button (click)="goToSofSingleDetail(btl.id)">
                <mat-icon>assignment</mat-icon> Review
              </button>

            </td>

          </tr>
        </table>

      </mat-card-content>
    </mat-card>


    <!-- DOCS (legacy) -->

    <mat-card class="content-card" *ngIf="currentUserIsAdminOrManagerOrAgent() && docsUploadFiles != null && docsUploadFiles.length > 0">
      <mat-card-header>
        <mat-card-title>
          <h5>Docs (legacy)</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="currentUserIsAdminOrComplianceOrManager() && lastDocLinkToken != null" style="margin-bottom: 15px;">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5>Upload documents</h5>
              </mat-panel-title>
              <mat-panel-description>

              </mat-panel-description>
            </mat-expansion-panel-header>


            <ngx-dropzone (change)="onSelectDocs($event)" [accept]="'image/*, application/pdf'" [multiple]="true"
                          [maxFileSize]="10485760" [disabled]="!currentUserIsAdminOrComplianceOrManager()">
              <ngx-dropzone-label *ngIf="true">UPLOAD</ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of filesDocs" [removable]="true" (removed)="onRemoveDocs(f)">
                <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
            <div [hidden]="!isUploading">
              <div class="spinner-2">
                <mat-spinner align="center"></mat-spinner>
              </div>
            </div>
            <button style="margin-top: 5px; margin-bottom: 15px;" *ngIf="true"
                    [disabled]="filesDocs == null || filesDocs.length <= 0 || isUploading" mat-raised-button color="primary" type="button"
                    (click)="uploadToDocs()">Upload
            </button>
          </mat-expansion-panel>
        </div>


        <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
          <tr>
            <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
            <th style="text-align: left; width: 60px;"><label>Type</label></th>
            <th style="text-align: left;"><label>File</label></th>
            <th style="text-align: left; width: 160px;"><label>Doc Type</label></th>
            <th style="text-align: left"><label>Status</label></th>
            <th style="text-align: left; width: 50px;"></th>
            <th style="text-align: left; width: 50px;"></th>
          </tr>
          <tr *ngFor="let f of docsUploadFiles">
            <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
            <td><label>{{f.typName}}</label></td>
            <td>
              <label *ngIf="currentUserIsAdminOrManager()">
                {{ f.originalFileName }}
              </label>
            </td>
            <td>
              <label>
                {{f.docType}}
              </label>
            </td>
            <td>
              <app-tri-state-checkbox [disabled]="isSaveDocsDisabled" style="margin-right: 3px;"
                                      *ngIf="f.mailSentDate == null" [(ngModel)]="f.isSuccess">
                <label *ngIf="f.isSuccess == true">Success</label>
                <label *ngIf="f.isSuccess == false">Failed</label>
                <label *ngIf="f.isSuccess == null">Pending</label>
              </app-tri-state-checkbox>
              <ng-container *ngIf="f.mailSentDate != null">
                <label *ngIf="f.isSuccess == true">Success</label>
                <label *ngIf="f.isSuccess == false">Failed</label>
                <label *ngIf="f.isSuccess == null">Pending</label>
              </ng-container>
            </td>
            <td>
              <button mat-mini-fab color="accent" (click)="downloadFile(f.id)" aria-label="download">
                <mat-icon matSuffix>cloud_download</mat-icon>
              </button>

            </td>
            <td>
              <button mat-mini-fab color="primary" (click)="openFile(f.id)" aria-label="preview">
                <mat-icon matSuffix>play_arrow</mat-icon>
              </button>

            </td>

          </tr>
        </table>

        <mat-card-actions align="end" *ngIf="customer">

          <div style="margin-right: 20px; margin-top: 10px;"
               [hidden]="docsUploadFiles == null || docsUploadFiles.length <= 0 || isSaveDocsDisabled">
            <label>Customer:&nbsp;&nbsp;</label>

            <app-tri-state-checkbox style="margin-left: 5px;"
                                    [disabled]="docsUploadFiles == null || docsUploadFiles.length <= 0"
                                    [(ngModel)]="customer.docsSuccess">
              <label *ngIf="customer.docsSuccess == true">Success</label>
              <label *ngIf="customer.docsSuccess == false">Failed</label>
              <label *ngIf="customer.docsSuccess == null">Pending</label>
            </app-tri-state-checkbox>
          </div>

          <button mat-raised-button color="primary"
                  [disabled]="docsUploadFiles == null || docsUploadFiles.length <= 0 || isSaveDocsDisabled"
                  (click)="save(docsUploadFiles)">Save and inform customer
          </button>
        </mat-card-actions>


      </mat-card-content>
    </mat-card>


  </div>
  <div fxFlex="55">

    <app-object-comments-view *ngIf="customer" [comments]="comments" [objectId]="customer?.id"
                              [target]="commentsTarget"></app-object-comments-view>


    <div [hidden]="true">
      <mat-card *ngIf="orders" class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Orders</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="list-item">
            <span fxFlex="25" *ngFor="let field of ordersFields">
                <label *ngIf="orders" class="secondary">{{field.header}}</label>

            </span>
            <span>&nbsp;</span>
          </div>
          <div class="list-item" fxLayout="row" *ngFor="let order of orders; let i = index">
                <span fxFlex="25" *ngFor="let field of ordersFields">
                  <label
                    class="{{ order.archived ? 'archived ': ''}}{{(order.status == 4 && field.header == 'Status' ) ? 'warning-row' : ''}}">{{field.cell(order)}}</label>
                </span>
          </div>
        </mat-card-content>

      </mat-card>
    </div>


    <mat-card *ngIf="customer" class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 *ngIf="filename == null">Preview</h5>
          <h5 *ngIf="filename != null">{{ filename }}</h5>
          <mat-error *ngIf="errorMsg != null">{{errorMsg}}</mat-error>

        </mat-card-title>
      </mat-card-header>
      <mat-card-content style="">

        <!--
        <div class="resp-container">
          <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
        </div>
        -->

        <iframe class="resp-iframe" height="1000" width="100%" [hidden]="isFrameHidden" frameBorder="1"
                [src]="urlSafe"></iframe>
        <img [src]="urlSafe" style="width: 100%; height:auto;" [hidden]="isImgHidden"/>


      </mat-card-content>
    </mat-card>


  </div>
</div>


